import { Users, Globe, Lightbulb } from "lucide-react";
import { useScrollReveal } from "../../hooks/useScrollReveal";

const pillars = [
  {
    icon: Users,
    title: "Senior-Level Audiences",
    description:
      "Our conferences are intimate, curated gatherings of C-suite executives, VPs, and directors — not mass trade shows. Every conversation matters.",
  },
  {
    icon: Globe,
    title: "Trusted Worldwide",
    description:
      "With 125 annual conferences across 8 industries, we've built deep relationships with the leaders who shape markets.",
  },
  {
    icon: Lightbulb,
    title: "Actionable Connections",
    description:
      "We design every session for real outcomes — not just panels and presentations, but the conversations that lead to partnerships, deals, and progress.",
  },
];

export const WhyIQHub = () => {
  const [ref, isVisible] = useScrollReveal();

  return (
    <section
      id="why-iqhub"
      ref={ref}
      className="py-24 bg-[#FAFAF8]"
    >
      <div className={`max-w-7xl mx-auto px-6 lg:px-8 transition-all duration-700 ${
        isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
      }`}>
        {/* Section Header */}
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="text-[#C8A951] text-4xl lg:text-5xl font-bold tracking-tight mb-6 block">
            Why IQ Hub
          </span>
          <h2 className="text-4xl lg:text-5xl font-bold text-[#0F172A] tracking-tight mb-4">
            Not Just Another Conference
          </h2>
          <p className="text-lg text-[#64748B] leading-relaxed">
            We don't do mass events. We create the rooms where the right people meet
            and the right conversations happen.
          </p>
        </div>

        {/* Pillars */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {pillars.map((pillar, i) => {
            const IconComponent = pillar.icon;
            return (
              <div
                key={i}
                className={`text-center px-6 py-8 transition-all duration-700`}
                style={{ transitionDelay: `${i * 150}ms` }}
              >
                <div className="w-14 h-14 rounded-2xl bg-[#0F172A] flex items-center justify-center mx-auto mb-6">
                  <IconComponent className="w-7 h-7 text-[#C8A951]" />
                </div>
                <h3 className="text-xl font-bold text-[#0F172A] mb-3">
                  {pillar.title}
                </h3>
                <p className="text-[#64748B] leading-relaxed">
                  {pillar.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Social Proof */}
        <div className="mt-16 pt-12 border-t border-[#E2E8F0] text-center">
          <p className="text-[#64748B] text-lg">
            Trusted by senior leaders from{" "}
            <span className="text-[#0F172A] font-bold">3000+ organizations</span>
            {" "}worldwide
          </p>
        </div>
      </div>
    </section>
  );
};
